import {string, bool, array, shape} from 'react-proptypes';

const config = {
  app: 'hypotheekbespaarcheck',
  initialFormData: {
    // landing
    original_mortgage_debt: null,
    original_house_value: null,
    house_purchase_year: null,

    // Current situation
    current_mortgage_debt: null,
    current_house_value: null,
    current_house_value_unknown: false,
    postal_code: null,
    estimated_current_house_value: null,

    // Interest rate
    interest_rate: null,
    interest_rate_unknown: false,
    estimated_interest_rate: '1-3',

    // fixed rate term
    variable_interest_rate: false,
    fixed_rate_term_end_month: null,
    fixed_rate_term_end_year: null,
    fixed_rate_term_end_unknown: false,
    estimated_fixed_rate_term_end: 24,

    // Mortgage provider
    mortgage_provider: null,
    product_line: null,
    nhg: false,

    // loanparts
    loanparts: [{variable_interest_rate: false}],

    // Applicant
    applicant_dob: '',
    applicant_income: null,
    applicant_income_period: 'monthly',
    applicant_holiday_bonus: true,
    applicant_13th_month_salary: false,
    applicant_is_entrepreneur: false,
    applicant_is_entrepreneur_for_three_years: true,
    applicant_entrepreneur_prognoses_current_year: null,
    applicant_entrepreneur_fiscal_profit_last_year: null,
    applicant_entrepreneur_fiscal_profit_two_years_ago: null,
    applicant_entrepreneur_fiscal_profit_three_years_ago: null,

    // Partner
    applicant_has_partner: false,
    partner_dob: '',
    partner_income: null,
    partner_income_period: 'monthly',
    partner_holiday_bonus: true,
    partner_13th_month_salary: false,
    partner_is_entrepreneur: false,
    partner_is_entrepreneur_for_three_years: true,
    partner_entrepreneur_prognoses_current_year: null,
    partner_entrepreneur_fiscal_profit_last_year: null,
    partner_entrepreneur_fiscal_profit_two_years_ago: null,
    partner_entrepreneur_fiscal_profit_three_years_ago: null,

    applicant_pension_income_period: 'yearly',
    partner_pension_income_period: 'yearly',

    applicant_showPension: false,
    partner_showPension: false,
  },
};

export const whiteListUrlParams = [
  // landing
  'original_mortgage_debt',
  'original_house_value',
  'house_purchase_year',

  // Current situation
  'current_mortgage_debt',
  'current_house_value',
  'current_house_value_unknown',
  'postal_code',
  'estimated_current_house_value',

  // Interest rate
  'interest_rate',
  'interest_rate_unknown',
  'estimated_interest_rate',

  // fixed rate term
  'variable_interest_rate',
  'fixed_rate_term_end_month',
  'fixed_rate_term_end_year',
  'fixed_rate_term_end_unknown',
  'estimated_fixed_rate_term_end',

  // Mortgage provider
  'mortgage_provider',
  'product_line',
  'nhg',

  // Applicant
  'applicant_dob',
  'applicant_income',
  'applicant_income_period',
  'monthly',
  'applicant_holiday_bonus',
  'applicant_13th_month_salary',
  'applicant_is_entrepreneur',
  'applicant_is_entrepreneur_for_three_years',
  'applicant_entrepreneur_prognoses_current_year',
  'applicant_entrepreneur_fiscal_profit_last_year',
  'applicant_entrepreneur_fiscal_profit_two_years_ago',
  'applicant_entrepreneur_fiscal_profit_three_years_ago',

  // Partner
  'applicant_has_partner',
  'partner_dob',
  'partner_income',
  'partner_income_period',
  'partner_holiday_bonus',
  'partner_13th_month_salary',
  'partner_is_entrepreneur',
  'partner_is_entrepreneur_for_three_years',
  'partner_entrepreneur_prognoses_current_year',
  'partner_entrepreneur_fiscal_profit_last_year',
  'partner_entrepreneur_fiscal_profit_two_years_ago',
  'partner_entrepreneur_fiscal_profit_three_years_ago',
  'applicant_pension_income_period',
  'partner_pension_income_period',

  'applicant_showPension',
  'partner_showPension',
]

export const MONTHS = [
  'Januari',
  'Februari',
  'Maart',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Augustus',
  'September',
  'Oktober',
  'November',
  'December',
];

export const MONTHS_OPTIONS = MONTHS.map((month, index) => {
  return {label: month, value: index + 1};
});

export const shapeSettings = shape({
  useFormalTranslation: bool,
  showLeadButton: bool,
  leadButtonText: string,
  leadFormHeader: string,
  leadFormText: string,
  enableHypotheekbondLogo: bool,
  enablePdf: bool,
  hideProvidersInResult: bool,
  enableDisclaimer: bool,
  requireEmailBeforePDFDownload: bool,
  requirePhonenumberBeforePDFDownload: bool,
  meta: shape({
    mortgage_providers: array,
    mortgage_types: array,
  }),
});

export default config;
